import { createSelector } from '@ngrx/store';
import { hasDownloadedHistoryOrders } from '../hasDownloadedHistoryOrders';
import { isLoadingAnyHistoryOrder } from '../isLoadingAnyHistoryOrder';

export const isRequestingHistoryOrderFirstTime = createSelector(
    hasDownloadedHistoryOrders,
    isLoadingAnyHistoryOrder,
    (hasDownloaded, isLoading) => hasDownloaded ? false : isLoading === true
);
